// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/ShippingAddressInfoDisplay";
import { GridOffset } from "@insite/mobius/GridContainer";
import { styledBoxStyle } from "@keller/App/Components/Common/StyledBox";
import { reviewSectionAddressesStyles } from "@keller/Overrides/Widgets/CheckoutShipping/SharedAddresses.style";
import { color, mergeWithCss } from "@keller/XDL/Utilities";
import { css } from "styled-components";

shippingAddressInfoDisplayStyles.container = {
    ...mergeWithCss(reviewSectionAddressesStyles.container, {
        css: css`
            ${GridOffset} {
                @media print {
                    margin: 0;
                    display: flex;
                    flex-direction: row;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    flex: 1;
                }
            }
            @media print {
                max-width: 500px;
                display: flex;
                flex-direction: column;
            }
        `,
    }),
};

shippingAddressInfoDisplayStyles.headingGridItem = {
    ...mergeWithCss(reviewSectionAddressesStyles.headingGridItem, {
        css: css`
            @media print {
                background-color: ${color("common.white")};
                border: 1px solid ${color("common.border")};
                border-bottom: 0;
                font-size: 12px;
                line-height: 18px;
                padding: 8px;
                margin: 0;
                display: flex;
                flex: 0;
            }
        `,
    }),
};

shippingAddressInfoDisplayStyles.heading = {
    ...mergeWithCss(reviewSectionAddressesStyles.heading, {
        css: css`
            @media print {
                font-size: 12px;
                line-height: 18px;
            }
        `,
    }),
};

shippingAddressInfoDisplayStyles.address = {
    ...mergeWithCss(shippingAddressInfoDisplayStyles.address, {
        wrapper: {
            css: css`
                @media print {
                    ${styledBoxStyle}
                    padding: 8px;
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
            `,
        },
    }),
    companyNameText: {
        ...reviewSectionAddressesStyles.address?.companyNameText,
    },
};

shippingAddressInfoDisplayStyles.addressGridItem = {
    width: 12,
    css: css`
        &&& {
            @media print {
                padding: 0;
                display: flex;
                flex-direction: column;
            }
        }
    `,
};

shippingAddressInfoDisplayStyles.editLink = {
    ...reviewSectionAddressesStyles.editLink,
};
